Immutable = require 'seamless-immutable'
{ did, doing } = require './common'
{ CREATED_DISTRICT, CREATING_DISTRICT, DELETED_DISTRICT, DELETING_DISTRICT, FETCHED_DISTRICTS, FETCHING_DISTRICTS, SELECT_DISTRICT, UPDATED_DISTRICT, UPDATING_DISTRICT } = require '../actions/districts'

baseState = Immutable {
	list: []
	isCreating: false
	isDeleting: false
	isFetching: false
	isUpdating: false
	selected: null
}

districts = (state = baseState, action) ->
	switch action.type
		when CREATING_DISTRICT
			state = doing 'isCreating', state
		when CREATED_DISTRICT
			state = did 'isCreating', state, action
		when DELETING_DISTRICT
			state = doing 'isDeleting', state
		when DELETED_DISTRICT
			state = did 'isDeleting', state, action
		when FETCHING_DISTRICTS
			state = doing 'isFetching', state
		when FETCHED_DISTRICTS
			state = did 'isFetching', state, action
		when SELECT_DISTRICT
			if action.payload.district
				localStorage.setItem 'district', action.payload.district.id
			else
				localStorage.removeItem 'district'

			state = state.set 'selected', Immutable action.payload.district
		when UPDATING_DISTRICT
			state = doing 'isUpdating', state
		when UPDATED_DISTRICT
			state = did 'isUpdating', state, action
	state

module.exports = districts



// WEBPACK FOOTER //
// ./frontend/olos/js/reducers/districts.coffee